import React, { useState, useEffect, useMemo } from 'react'
import axios from 'axios'
import Style from './App.css'
import MyNavBar from './myNavBar.js'
import Modal from 'react-modal'
import moment from "moment";
import { Container, Row, Col } from 'react-bootstrap';
import ReactExport from "react-data-export";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

// Exporting excel with a proper way
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function MyCustomerDeliveryReport(props) {
  const [orders, setOrders] = useState([])
  const [openCriteria, setOpenCriteria] = useState(true);
  const [loading, setLoading] = useState(false);

  const [beginDate, setBeginDate] = useState(moment().subtract(90, "days").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().add(1, "days").format("YYYY-MM-DD"));

  // For getting search result report. İt will be useful
  const [totalQty, setTotalQty] = useState(0);
  const [totalSubQty, setTotalSubQty] = useState(0);
  const [totalLineCount, setTotalLineCount] = useState(0);

  let basurl = window.location.hostname;
  let userName = localStorage.getItem("userName");
  let companyId = localStorage.getItem("company");

  function compare(a, b) {
    const pkA = a.Id;
    const pkB = b.Id;

    let comparison = 0;

    if (pkA > pkB) {
      comparison = 1;
    } else if (pkA < pkB) {
      comparison = -1;
    }
    return comparison;
  }


  function getSafeAndDeliveryTransactionReport(event) {
    setLoading(true)
    event.preventDefault();
    setOrders([]);
    const url = `http://${basurl}:9091/api/reports/getCustomerDeliveryReport`
    axios.get(url, {
      params: {
        UserName: userName,
        companyId: companyId,
        BeginDate: beginDate,
        EndDate: endDate
      }
    })
      .then(res => {
        if(res.data&&res.data.length){
          const orders = res.data.sort(res.data.Id);
          //we did the sorting
          setOrders(orders);
          setTimeout(()=>setLoading(false),2000) 
        }else{
          setOrders([]);
          setTimeout(()=>setLoading(false),2000) 
        }
      });
    renderTableData()
  }

  useEffect(() => {
    setTotalQty(orders.reduce((currentTotal, item) => {
      return item.QTY + currentTotal
    }, 0).toFixed(2));
    setTotalSubQty(orders.reduce((currentTotal, item) => {
      return item.TROD_CUQUANTITY + currentTotal
    }, 0).toFixed(2));
    setTotalLineCount(orders.length);
  }, [orders])

  function renderTableData() {
    return orders.sort((a,b)=>a.TROR_ORDERDATE-b.TROR_ORDERDATE)
    .map((order, index) => {
      const { TROR_ID, TROR_ORDERDATE, TROR_CODE,TROR_OFFICIALDOCUMENTNO, TROR_CUSTOMERORDERNUMBER, TROR_DEPOSITORSDOCUMENT, TRIP_PLANNEDDEPARTDATETIME, TRIP_CODE, QTY, TROD_CUQUANTITY, TRPR_DESCRIPTION,TRPT_DESCRIPTION, TROR_TOADRESS, VEHI_PLATENUMBER,DRIVNAMESURNAME,TROS_DESCRIPTION,TROR_ACTUALDELIVERYDATETIME } = order //destructuring
      return (
        <tr key={TROR_ID} className="tableRow">
          <td>{moment(TROR_ORDERDATE).format("DD.MM.YYYY")}</td>
          <td>{TROR_CODE}</td>
          <td>{TROR_OFFICIALDOCUMENTNO}</td>
          <td>{TROR_CUSTOMERORDERNUMBER}</td>
          <td>{TROR_DEPOSITORSDOCUMENT}</td>
          <td>{moment(TRIP_PLANNEDDEPARTDATETIME).format("DD.MM.YYYY")}</td>
          <td>{TRIP_CODE}</td>
          <td>{QTY}</td>
          <td>{TROD_CUQUANTITY}</td>
          <td>{TRPR_DESCRIPTION}</td>
          <td>{TRPT_DESCRIPTION}</td>
          <td>{TROR_TOADRESS}</td>
          <td>{VEHI_PLATENUMBER}</td>
          <td>{DRIVNAMESURNAME}</td>
          <td>{TROS_DESCRIPTION}</td>
          <td>{TROR_ACTUALDELIVERYDATETIME?moment(TROR_ACTUALDELIVERYDATETIME).format("DD.MM.YYYY"):""}</td>
        </tr>
      )
    })
  }

  if(loading){
    return (
      <div className="master">
      <div className="Form1">
        <MyNavBar userName={userName} conpanyID={companyId}></MyNavBar>
      </div>
    <Loader
    type="ThreeDots"
    color="#00BFFF"
    height={"20%"}
    width={"20%"}
    timeout={4000}
  />
  </div>
  );
  }else{
    return (
      <div className="master">
        <div className="Form1">
          <MyNavBar userName={userName} conpanyID={companyId}></MyNavBar>
        </div>
        {openCriteria?
          <div>
          <Container fluid className="border border-warning" style={{marginBottom:"20px"}}>
            <Row>
              <Col  sm={6}>
                <label for="start">Başlangıç Tarihi:</label>
                <input type="date" id="start" name="trip-start" value={beginDate}  onChange={(e)=>setBeginDate(e.target.value)} min="2018-01-01" max="2028-12-31"></input>
              </Col>
              <Col  sm={6}>
                <label for="start">Bitiş Tarihi:</label>
                <input type="date" id="start" name="trip-start" value={endDate}  onChange={(e)=>setEndDate(e.target.value)} min="2018-01-01" max="2028-12-31"></input>
              </Col>
            </Row>
          </Container>
      </div>
      :""
        }
        
        <div>
            <button type="button" style={{ width: "40%", height: "30px" }} onClick={getSafeAndDeliveryTransactionReport} value="Submit" className="btn btn-success">Siparişleri Getir</button>&nbsp;&nbsp;
            <button type="button" style={{ width: "40%", height: "30px" }} onClick={()=>setOpenCriteria(!openCriteria)} value="updateCriteras" className="btn btn-warning">{openCriteria?'Kriterleri Gizle':'Kriterleri Göster'}</button>
        </div>
        <div className="Form1">
          <table id="table-to-xls" className="Form1">
            <thead>
              <tr>
              <td>Sipariş Tarihi</td>
              <td>Sipariş</td>
              <td>ATF/Tİ No</td>
              <td>Referans no</td>
              <td>Sip/Sevk Irs. No</td>
              <td>Sefer Tarihi</td>
              <td>Sefer</td>
              <td>Kap Adeti</td>
              <td>Alt Birim Miktarı</td>
              <td>Ürün</td>
              <td>Paket Tipi</td>
              <td>Varış Adresi</td>
              <td>Plaka</td>
              <td>Sürücü</td>
              <td>Sipariş Statüsü</td>
              <td>Ger.Tes.Tarihi</td>
              </tr>
            </thead>
            <tbody>
              {renderTableData()}
            </tbody>
            <tr>
              <th colspan="10"></th>
            </tr>
            <tr>
              <th colspan="3">Toplam Satır Sayısı:{totalLineCount}</th>
              <th colspan="4">Totals :</th>
              <th>{totalQty}</th>
              <th>{totalSubQty}</th>
              <th colspan="7"></th>
            </tr>
          </table>
        </div>
        <div className="Form2">
          <Container fluid className="border border-warning" style={{marginBottom:"20px"}}>
            <Row>
              <ExcelFile element={
                <Col sm={12}>
                  <button
                    type="submit"
                    value="Submit"
                    class="btn btn-info"
                  >
                    Excel'e Aktar
                  </button>
                </Col>
              }>
                <ExcelSheet data={orders} name="Siparişler">
                  <ExcelColumn label="Sipariş Tarihi" value="TROR_ORDERDATE" />
                  <ExcelColumn label="Sipariş" value="TROR_CODE" />
                  <ExcelColumn label="ATF/Tİ No" value="TROR_OFFICIALDOCUMENTNO" />
                  <ExcelColumn label="Referans no" value="TROR_CUSTOMERORDERNUMBER" />
                  <ExcelColumn label="Sip/Sevk Irs. No" value="TROR_DEPOSITORSDOCUMENT" />
                  <ExcelColumn label="Sefer Tarihi" value="TRIP_PLANNEDDEPARTDATETIME" />
                  <ExcelColumn label="Sefer" value="TRIP_CODE" />
                  <ExcelColumn label="Kap Adeti" value="QTY" />
                  <ExcelColumn label="Alt Birim Miktarı" value="TROD_CUQUANTITY" />
                  <ExcelColumn label="Ürün" value="TRPR_DESCRIPTION" />
                  <ExcelColumn label="Paket Tipi" value="TRPT_DESCRIPTION" />
                  <ExcelColumn label="Varış Adresi" value="TROR_TOADRESS" />
                  <ExcelColumn label="Plaka" value="VEHI_PLATENUMBER" />
                  <ExcelColumn label="Sürücü" value="DRIVNAMESURNAME" />
                  <ExcelColumn label="Sipariş Statüsü" value="TROS_DESCRIPTION" />
                  <ExcelColumn label="Ger.Tes.Tarihi" value="TROR_ACTUALDELIVERYDATETIME" />
                </ExcelSheet>
              </ExcelFile>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
}

export default MyCustomerDeliveryReport;
